var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "section",
        [
          _c(
            "b-tabs",
            {
              attrs: { type: "is-boxed", animated: false },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            [
              _vm._l(_vm.tabItems, function(tab) {
                return [
                  _c(
                    "b-tab-item",
                    {
                      key: tab.id,
                      attrs: {
                        value: tab.id,
                        label: _vm.$t("menu." + tab.label)
                      }
                    },
                    [
                      _vm.selectedTab === tab.id
                        ? _c(
                            tab.component,
                            _vm._b(
                              { tag: "component" },
                              "component",
                              { unitId: _vm.unitId },
                              false
                            )
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      ),
      _c("b-loading", {
        attrs: { "is-full-page": true, active: _vm.isLoading },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }